<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="text-right m-2">
      <b-button v-if="$localStorageService.can('Conf_TDC_nuevo')"
                pill size="sm" variant="info"
                v-b-tooltip.hover.topleft.v-light
                title="Nuevo registro"
                @click="showModal"
      >
        <b-icon icon="credit-card"></b-icon>
      </b-button>
    </div>

    <div class="contenedorTablaSinColor text-center m-2 " style="border-radius: 10px;">
      <b-row >
        <b-col sm="12" md="12" lg="12" >
          <b-table
              responsive
              id="tablaTDC"
              thead-tr-class="columnasTablaSinColor"
              :items="configuracionesMsiProps"
              :fields="fields"
              :per-page="registrosPorPagina"
              :current-page="paginaActual"
              selectable
              class="parrafos"
              fixed
              hover>
            <template #cell(montoMinimoMsi)="row">
              {{row.item.montoMinimoMsi | monedaEntero}}
            </template>
            <template #cell(estatusMsi)="row">
              <div class="text-center" style="display:flex">
                <b-form-checkbox
                    :id="'checkTdc-' + row.item.idDetallePlazoFijo"
                    :name="'checkTdc-' + row.item.idDetallePlazoFijo"
                    switch
                    v-model="row.item.estatusMsi"
                    v-b-tooltip.hover.lefttop.v-light
                    :title="row.item.estatusMsi ? 'Msi Activos' : 'Msi inactivos'"
                    @input="cambiarEstatusMsi(row.item)"
                ></b-form-checkbox>
              </div>
            </template>
            <template #cell(aplicaCostoFinanciamiento)="row">
              <div class="text-center" style="display:flex">
                <b-form-checkbox
                    :id="'checkACF-' + row.item.idDetallePlazoFijo"
                    :name="'checkACF-' + row.item.idDetallePlazoFijo"
                    switch
                    v-model="row.item.aplicaCostoFinanciamiento"
                    v-b-tooltip.hover.lefttop.v-light
                    :title="row.item.aplicaCostoFinanciamiento ? 'Costo financiamiento Activo' : 'costo financiamiento inactivos'"
                    @input="cambiarEstatusCostoFinanciam(row.item)"
                ></b-form-checkbox>
              </div>
            </template>
            <template #cell(porcentajeFinanciamiento)="row">
              {{row.item.porcentajeFinanciamiento }}%
            </template>
            <template #cell(bancos)="row">
<!--              v-if="row.item.bancos.length <= 2"-->
              <div class=" justify-content-center" v-if="row.item.bancos.length <= 2" style="display: -webkit-box;">
                <div v-for="b in row.item.bancos" :key="b.idTerminal">
                  <span style="color: rgba(255,255,255,0)">,</span>
                  <span>{{ b.nombre }}, </span>
                </div>
              </div>
              <div v-else style="display: inline-block">
                <div :id="'bancos'+row.item.idDetallePlazoFijo">
                  <span  style="text-decoration: underline; color: #84a7c8">{{row.item.bancos[0].nombre}}</span>
                  <span  style="text-decoration: underline; color: #84a7c8"> +{{ (row.item.bancos.length -1) }} más </span>
                </div>


                <b-popover :target="'bancos'+row.item.idDetallePlazoFijo" triggers="click blur" placement=" right">
                  <span style="color: #4B94C2; font-size: 10px">Bancos asociados a la configuración:</span>
                  <div  class="text-center" v-for="op in  row.item.bancos"
                        :key="op.nombre"
                        style="padding-left: 4vh;"
                  >
                      <table>
                        <tr>
                          <th style="font-size: 11px; display: list-item;">
                             {{op.nombre}}
                          </th>
                        </tr>
                      </table>
                  </div>
                </b-popover>

              </div>

            </template>

            <template v-slot:cell(Acciones)="row">
              <b-spinner v-if="row.item.loaderInactivar"
                         variant="info"
                         label="Spinning"
                         small
              ></b-spinner>
              <b-button-group v-else>

                  <em v-if="row.item.registroActivo && $localStorageService.can('Conf_TDC_editar')"
                      class="editarV5"
                      style="width: 22px; cursor: pointer"
                      v-b-tooltip.hover.rightbottom.v-light
                      title="Editar registro"
                      @click="editarMsi(row.item)"
                  ></em>

                  <em class="inactivarV5"
                      style="width: 22px; cursor: pointer;margin-left: 12px;"
                      v-if="row.item.registroActivo && $localStorageService.can('Conf_TDC_activar')"
                      v-b-tooltip.hover.bottomright.v-light
                      title="Inactivar registro"
                      @click="inactivarMSI(row.item)"
                  ></em>
                <em class="activar_kit"
                      style="width: 22px; cursor: pointer;margin-left: 12px;"
                      v-if="!row.item.registroActivo && $localStorageService.can('Conf_TDC_activar')"
                      v-b-tooltip.hover.bottomright.v-light
                      title="Activar registro"
                      @click="inactivarMSI(row.item)"
                  ></em>


              </b-button-group>
            </template>
          </b-table>
          <b-spinner variant="info" v-if="cargandoPF" label="cargandoPf" small></b-spinner>
          <b-alert show info v-if="configuracionesMsiProps.length === 0 && !cargandoPF">No hay registros de Configuración Tdc </b-alert>

        </b-col>
      </b-row>
    </div>


    <b-modal ref="nueva-tdc" size="lg" hide-footer  hide-header no-close-on-esc no-close-on-backdrop>
      <div class="d-flex" style="color: #044169; position: absolute; font-weight: 600; width: 36%">
        <em class="calculad" style="width: 8%"></em>
        <span v-if="guardar.idDetallePlazoFijo !== null" class="textSize ml-4" style="font-weight: 600;">Editar configuración tdc</span>
        <span v-else class="textSize ml-4" style="font-weight: 600;">Nueva configuración tdc</span>

      </div>
      <br/>
      <br/>
      <div >
        <b-form v-on:submit.prevent="guardarConfiguracion" >
          <b-row class="m-3">
            <b-col >
                <label> Número de meses (plazos)</label>
              <v-select
                  :options='guardar.idDetallePlazoFijo === null ? mesesBancos : mesesProps'
                  id="idPlazoFijo"
                  label="numeroPlazo"
                  v-model="guardar.numeroMsi"
                  :reduce="(variable) => variable.idPlazoFijo"
                  :disabled="editar"
                  :clearable="false"
              ></v-select>
                <b-form-invalid-feedback :state="guardar.numeroMsi != null">
                  Seleccione una opción
                </b-form-invalid-feedback>

            </b-col>
            <b-col class="text-center ">

              <label>¿Msi activo?</label>
              <div class="d-flex justify-content-center">
                <b-form-checkbox v-model="guardar.msiActivo" name="check-button" switch/>
                <b-form-invalid-feedback >
                  Se debe seleccionar una opción
                </b-form-invalid-feedback>
              </div>
            </b-col>
            <b-col class="text-center ">

              <label>¿Costo Financiamiento activo?</label>
              <div class="d-flex justify-content-center">
                <b-form-checkbox v-model="guardar.costoFinanciamientoActivo" name="check-button" switch/>
                <b-form-invalid-feedback >
                  Se debe seleccionar una opción
                </b-form-invalid-feedback>
              </div>
            </b-col>
            <b-col>
              <label>Monto mínimo de MSI</label>
              <b-form-input
                  type="number"
                  placeholder="$0"
                  min="0"
                  v-model="guardar.montoMinimo"
                  @keydown="filterJustNumber($event)"
              />
              <b-form-invalid-feedback :state="guardar.montoMinimo != null">
                Se debe seleccionar una opción
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
          <br/>
          <b-row class="m-3">
            <b-col >
              <label> Costo de financiamiento (porcentaje) sin IVA </label>
              <b-form-input
                  type="number"
                  max="100"
                  min="1"
                  placeholder="0%"
                  v-model="guardar.costoFinanciamiento"
                  @keydown="filterJustNumber($event)"
                  @keyup="validarDesc(guardar.costoFinanciamiento)"
              ></b-form-input>
              <b-form-invalid-feedback :state="guardar.costoFinanciamiento != 0 && guardar.costoFinanciamiento != null  ">
                Ingrese un dato válido
              </b-form-invalid-feedback>

            </b-col>
            <b-col>
              <label>Bancos</label>
              <v-select
                  :options="bancosProps"
                  id="idTerminal"
                  label="nombre"
                  multiple
                  v-model="guardar.bancos"
                  :reduce="(variable) => variable.idTerminal"
              ></v-select>
              <b-form-invalid-feedback :state="guardar.bancos.length != 0 " >
                Seleccione al menos un banco
              </b-form-invalid-feedback>
            </b-col>
          </b-row>


        </b-form>

        <div style="padding:1%" class="text-center">
          <b-button variant="info" class="mt-4"
                    type="submit" size="sm"
                    @click="guardarConfiguracion" pill
                    style="padding-left: 4%; padding-right: 4%;"
                    :disabled="loaderGuardar"
          >
            <span v-if="!loaderGuardar">Guardar</span>
            <b-spinner v-else small />
          </b-button>
          <b-button variant="outline-secondary" class="mt-4" type="submit" size="sm" @click="hideModal" pill
                    style=" padding-left: 4%; padding-right: 4%; margin-left: 20px;">
            Cancelar
          </b-button>
        </div>
      </div>

    </b-modal>



  </div>
</template>

<script>
export default {
  name: "TdcClinica",
  props:{
    mesesProps: Array,
    bancosProps: Array,
    idClinicaProp: Number,
    configuracionesMsiProps: Array,
    cargandoPF: Boolean,
  },
  data:()=> {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      mesesBancos: [],
      registrosPorPagina: 10,
      paginaActual:1,
      fields: [
        {key: "meses", label: "Meses"},
        {key: "montoMinimoMsi", label: "Monto Mínimo MSI"},
        {key: "estatusMsi", label: "Estatus Msi"},
        {key: "aplicaCostoFinanciamiento", label: "Estatus Costo financiamiento"},
        {key: "porcentajeFinanciamiento", label: "Porcentaje de financiamiento sin Iva"},
        {key: "bancos", label: "Bancos"},
        {key: "estatus", label: "Estatus"},
        "Acciones",
      ],

      guardar: {
        numeroMsi: null,
        msiActivo: true,
        costoFinanciamientoActivo: true,
        montoMinimo: 0,
        costoFinanciamiento: 0,
        bancos: [],
        idClinica: null,
        idDetallePlazoFijo: null,
      },
      editar: false,
      loaderGuardar: false,
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    editarMsi(item){
      console.log("_item", item)
      this.editar = true;
      this.guardar.numeroMsi = item.idPlazoFijo;
      this.guardar.msiActivo = item.estatusMsi;
      this.guardar.costoFinanciamientoActivo = item.aplicaCostoFinanciamiento;
      this.guardar.montoMinimo = item.montoMinimoMsi;
      this.guardar.costoFinanciamiento = item.porcentajeFinanciamiento;
      this.guardar.bancos = item.bancos;
      this.guardar.idDetallePlazoFijo = item.idDetallePlazoFijo;
      this.$refs['nueva-tdc'].show()
    },
    inactivarMSI(item){
      item.idClinica = this.idClinicaProp
      item.loaderInactivar = true;

      this.$http.post(this.$api + "plazoFijo/inactivarMsiActivar", item)
          .then((resp) => {
            item.loaderInactivar = false;
            item.registroActivo = resp.data.data
            item.estatus = resp.data.data ? 'Activo' : 'Inactivo'
          })
    },
    cambiarEstatusMsi(item){
      item.idClinica = this.idClinicaProp;

      this.$http.post(this.$api + "plazoFijo/cambiarEstatusMsi", item)
          .then((resp) => {
           item.estatusMsi= resp.data.data;
          })
    },
    cambiarEstatusCostoFinanciam(item){
      item.idClinica = this.idClinicaProp;

      this.$http.post(this.$api + "plazoFijo/cambiarCostoFinanciamiento", item)
          .then((resp) => {
           item.aplicaCostoFinanciamiento= resp.data.data;
          })
    },
    guardarConfiguracion(){
      if (this.guardar.numeroMsi == null ||
      this.guardar.msiActivo == null ||
      this.guardar.costoFinanciamientoActivo == null ||
      this.guardar.montoMinimo == null ||
      this.guardar.costoFinanciamiento == null || this.guardar.costoFinanciamiento == 0 ||
      this.guardar.bancos.length == 0   ){

        this.$swal.fire({
          icon: "warning",
          text: "Por favor complete los datos obligatorios",
          showConfirmButton: false,
          timer: 1500
        });

      } else {

        this.guardar.idClinica = this.idClinicaProp;
        console.log("terminal--> ", this.guardar.bancos[0])
        if (this.guardar.idTerminal !== null && this.guardar.idTerminal !== undefined ) {
          this.guardar.bancos = this.guardar.bancos.map(m => m.idTerminal)
        }
        if (this.guardar.bancos[0].idTerminal !== null && this.guardar.bancos[0].idTerminal !== undefined ) {
          this.guardar.bancos = this.guardar.bancos.map(m => m.idTerminal)
        }

        this.loaderGuardar = true

        this.$http.post(this.$api + "plazoFijo/guardarMsiClinica", this.guardar)
            .then((resp) => {
              if (resp.data.data) {
                this.loaderGuardar = false;
                this.obtenerConfiguracionPlazos();
                this.hideModal();
              }
            })
      }
    },
    obtenerConfiguracionPlazos(){
      this.$emit('obtenerConfiguracionPlazos');
    },
    showModal() {
      this.mesesBancos = [];
      this.editar = false;
      this.guardar = {
        numeroMsi: null,
            msiActivo: true,
            costoFinanciamientoActivo: true,
            montoMinimo: 0,
            costoFinanciamiento: 0,
            bancos: [],
            idClinica: null,
            idDetallePlazoFijo: null,
      };
          if(this.configuracionesMsiProps.length > 0){
            this.mesesProps.forEach(m => {
              if (!this.configuracionesMsiProps.map(c => c.idPlazoFijo).includes(m.idPlazoFijo)){
                this.mesesBancos.push(m);
              }

            })
          }else{
            this.mesesBancos = this.mesesProps;
          }






      this.$refs['nueva-tdc'].show()
    },
    hideModal() {
      this.$refs['nueva-tdc'].hide()
    },
    validarDesc(descuento){
      if (descuento > 100){
        this.guardar.costoFinanciamiento = 100;
      }
    },
    filterJustNumber(e){
      const key = e.key;

      if (key === '-'){
        return e.preventDefault();
      }

      if (key === '+'){
        return e.preventDefault();
      }

      if (key === '.'){
        return e.preventDefault();
      }

      // OPTIONAL
      // If is 'e' key, stop it
      if (key === 'e'){
        return e.preventDefault();
      }

    },
  }
}
</script>

<style scoped>

</style>